import React from 'react';
import '../css/Header.css';

const Header = () => {
	return (
		<div id="header-container">
			<h1 id="title">Vision</h1>
			<p className="text">A chess coordinate guesser</p>
		</div>
	);
}

export default Header;
